// extracted by mini-css-extract-plugin
export default {"layout":"\"../../../../styles/variables/layout.module.css\"","breakpoint-s":"600px","wrapper":"Modal_wrapper__UC3nr"};